import e from"./divider";export{StyledDivider,StyledDividerText}from"./divider.styles";export default e;